import defineMessages from "../../../../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    selectScore: {
        id: "tasks.barSorting.selectScore",
    },
    uploadScore: {
        id: "tasks.barSorting.uploadScore",
    },
    deleteScore: {
        id: "tasks.barSorting.deleteScore",
    },
    fileUpload: {
        id: "general.fileUpload",
    },
    fileIncorrectFormat: {
        id: "general.fileIncorrectFormat",
    },
    imageTypes: {
        id: "tasks.barSorting.imageTypes",
    },
    close: {
        id: "general.close",
    },
});

export default messages;
